export default __webpack_public_path__ + "static/16072-bf412379e03baeffa9e7a3d976fa12a6.jpg";